// extracted by mini-css-extract-plugin
export default {"wrapper":"contentBanner_wrapper__4dd+i","subTitle":"contentBanner_subTitle__EZtWT","titleWrapper":"contentBanner_titleWrapper__euYs0"};